<template>
  <div class="page-error">
    <Header />
    <div class="main-wrap clearfix">
      <div class="err-img"></div>
      <p class="err-tip">抱歉~当前账号暂无企业中心访问权限</p>
      <div class="actions">
        <el-button type="primary" size="large" clstag="pageclick|keycount|401|changeAccount" @click="logout">切换账号</el-button>
        <el-button functional size="large" clstag="pageclick|keycount|401|goResigt" @click="goRegist">去开通</el-button>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// import store from '@/store';
import Header from '@/components/layout/header.vue';
import Footer from '@/components/layout/footer.vue';
import { isJMSupportQY, openJMQYLogin, isInJMAndNoQY } from '../../utils/jmsdk';

export default {
  name: 'Error401',
  components: {
    Header,
    Footer,
  },
  mounted() {
    // 如果是在京麦客户端中，且京麦不支持企业账号，则提示升级客户端
    if (isInJMAndNoQY) {
      this.tipDownloadNewJm();
    }
  },
  methods: {
    tipDownloadNewJm() {
      this.$confirm('请升级京麦客户端，体验京麦企业工作台', {
        type: 'warning',
      }).then(() => {
        window.location.href = 'https://jm.jd.com';
      });
    },
    // 切换账号
    logout() {
      // 如果是在京麦客户端中，且京麦不支持企业账号，则提示升级客户端
      if (isInJMAndNoQY) {
        this.tipDownloadNewJm();
        return;
      }
      // 如果是在京麦客户端中，且京麦支持企业账号，则打开京麦的登录窗口
      if (isJMSupportQY) {
        openJMQYLogin();
        return;
      }

      window.location.href = `//passport.shop.jd.com/login/logout.action?logoutSource=jmqy&ReturnUrl=${encodeURIComponent(window.location.origin)}`;
    },
    // 去开通
    goRegist() {
      // 如果是在京麦客户端中，且京麦不支持企业账号，则提示升级客户端
      if (isInJMAndNoQY) {
        this.tipDownloadNewJm();
        return;
      }

      // this.$router.push({ name: 'regist' });
      window.location.href = '//passport.shop.jd.com/login/index.action/jdm?source=14';
    },
  },
};
</script>

<style lang="scss" scoped>
.page-error {
  .main-wrap {
    width: 1260px;
    margin: 20px auto 0;
    padding-bottom: 119px;
    min-height: calc(100vh - 168px - 100px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    background: #fff;
    text-align: center;
    border-radius: 2px;
  }
  .err-img {
    margin: 119px auto 0;
    width: 300px;
    height: 200px;
    background-image: url('https://img14.360buyimg.com/imagetools/jfs/t1/182227/15/10609/23748/60d19505E5c2adaf9/b2f86d949ed88d47.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .err-tip {
    margin: 20px auto 40px;
    font-size: 14px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.45);
  }
}
</style>
